import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "student-teacher-collaboration"
    }}>{`Student-Teacher Collaboration`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`The most effective and rewarding learning environments allow for seamless collaboration between teachers and students. The sudden rise in virtual learning environments has made this goal difficult to achieve, as different file formats, user platforms, and diverse learning levels make it much harder for students to maximize their learning.`}</p>
    <p>{`Adobe Acrobat Services enables students to:`}</p>
    <ul>
      <li parentName="ul">{`View learning materials in a seamless web experience despite multiple document formats`}</li>
      <li parentName="ul">{`Collaborate easily with teachers and peers to benefit from the full classroom environment`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A teacher needs to share classroom material, but it is in a variety of formats, and not all students have the same apps and devices. Documents in Microsoft Word, Excel, PowerPoint, and HTML are converted to PDFs and embedded in course websites. Students annotate the documents, collaborate virtually with each other, and teachers see which students are engaged with certain material.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create learning material in PDF programmatically by converting and combining documents in multiple formats using Adobe PDF Services API`}</li>
      <li parentName="ol">{`Provide the learning material in a high-fidelity PDF viewing experience`}</li>
      <li parentName="ol">{`Enable annotations for multiple students on embedded PDF documents`}</li>
      <li parentName="ol">{`Create supplemental learning material by archiving annotations on embedded PDF documents`}</li>
      <li parentName="ol">{`Track engagement and understand learning needs by using analytics events tracked in embedded PDF documents`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      